// How a school is named in a picker.
//
// Several schools share a name -- the Lincolns, the Roosevelts, the Washingtons
// -- so the name alone leaves a parent guessing which one is theirs. The city
// in parentheses is what the admin screens already show, and this is the one
// place that spelling is defined so the customer and admin pickers cannot drift
// apart the way two hand-rolled copies did.
//
// Falls back to the bare name: `cityName` is null for a school with no city
// record, and "Lincoln High ()" would be worse than "Lincoln High".
//
// Some names ALREADY carry a parenthetical, and the office has used it for two
// different things: the city ("Lincoln Elementary (Stockton)") and the district
// ("Lincoln Elementary (West Contra Costa)"). Appending blindly gave
// "Lincoln Elementary (Stockton) (Stockton)". So the test is whether the name
// already says the CITY -- a district in parentheses still leaves the city
// worth adding, which is why this does not simply skip any name ending in ")".
export const schoolLabel = (school) => {
  if (!school) return '';
  if (!school.cityName) return school.name;

  const name = String(school.name || '');
  if (name.toLowerCase().includes(String(school.cityName).toLowerCase())) return name;

  return `${name} (${school.cityName})`;
};

export default schoolLabel;
